import { createSelector } from '@reduxjs/toolkit';
import { selectConstraints } from '../../store/selectors';

export const selectSecurityConstraints = createSelector(selectConstraints, (constraints) => {
  return constraints.securityConstraints;
});
